import React from 'react';
import { Section } from './Section';
export function BigIdea() {
  return <Section background="forest" labelledBy="big-idea-heading" data-id="element-28" data-mp="2p9ycnpdqrmbr">
      <div className="mx-auto max-w-3xl text-center" data-id="element-29" data-mp="2p852i03x6jz0">
        <h2 id="big-idea-heading" className="font-serif text-3xl font-semibold leading-[1.15] text-white sm:text-[40px]" data-id="element-30" data-mp="2u8roldddr59t">
          The difference between the instructor who freezes and the instructor who calmly adjusts
          the plan isn't more anatomy.
        </h2>

        <p className="mt-7 font-serif text-3xl font-medium italic leading-tight text-brass sm:text-[44px]" data-id="element-31" data-mp="26ip0f8cl6jgh">
          It's a protocol.
        </p>

        <p className="mt-8 font-sans text-[17px] leading-[1.65] text-white/70 sm:text-lg" data-id="element-32" data-mp="2bggp7thxppgg">
          Pilots don't memorize the flight manual — they run checklists. ER doctors don't improvise
          — they triage. Anatomy tells you what a herniated disc is. A protocol tells you what to do
          at 8:57 AM. And until now, nobody handed Pilates instructors the protocol.
        </p>
      </div>
    </Section>;
}